import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import HomeNew from "@/pages/HomeNew";
import Contact from "@/pages/Contact";
import Presentation from "@/pages/Presentation";
import Boutique from "@/pages/Boutique";
import Commander from "@/pages/Commander";
import Simulateur from "@/pages/Simulateur";
import Technologie from "@/pages/Technologie";
import Installation from "@/pages/Installation";
import AdminAvis from "@/pages/AdminAvis";
import FAQ from "@/pages/FAQ";
import Histoire from "@/pages/Histoire";
import Temoignages from "@/pages/Temoignages";
import DevenirPartenaire from "@/pages/DevenirPartenaire";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomeNew />} />
          <Route path="/presentation" element={<Presentation />} />
          <Route path="/technologie" element={<Technologie />} />
          <Route path="/boutique" element={<Boutique />} />
          <Route path="/boutique/:category" element={<Boutique />} />
          <Route path="/commander" element={<Commander />} />
          <Route path="/simulateur" element={<Simulateur />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/installation" element={<Installation />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/histoire" element={<Histoire />} />
          <Route path="/temoignages" element={<Temoignages />} />
          <Route path="/devenir-partenaire" element={<DevenirPartenaire />} />
          <Route path="/admin/avis" element={<AdminAvis />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
